// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ThreeGraphsRow_wrapper__1WbT4"};